import { itemTypeConfigMap } from '@wix/a11y-wizard-common';
import { Box, SectionHelper, Text } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { StatusWarningSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
const VerticalsDrillInMaxPagesWarning = _ref => {
  var _itemTypeConfigMap;
  let {
    itemType
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    padding: "14px 20px"
  }, /*#__PURE__*/React.createElement(SectionHelper, {
    appearance: "warning",
    children: /*#__PURE__*/React.createElement(Text, {
      size: "tiny"
    }, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: `accessibility-wizard.verticals-drill-in.content-section.max-pages-warning.text.${itemType}`,
      values: {
        maxImages: itemType ? itemTypeConfigMap == null || (_itemTypeConfigMap = itemTypeConfigMap[itemType]) == null ? void 0 : _itemTypeConfigMap.pageLimit : ''
      }
    })),
    prefixIcon: /*#__PURE__*/React.createElement(Box, {
      verticalAlign: "top"
    }, /*#__PURE__*/React.createElement(StatusWarningSmall, null)),
    showPrefixIcon: true
  }));
};
export default VerticalsDrillInMaxPagesWarning;
//# sourceMappingURL=verticals-drill-in-max-pages-warning.js.map